import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "label", "loading", "themeColorPrimary"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { theme } from 'styled-tools';
import UISpinner from '@/components/ui/spinner';
import { spacingVer } from '@/components/utils/style';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StyledLoader = styled.div.withConfig({
  displayName: "StyledLoader",
  componentId: "sc-ymhjm4-0"
})(["display:flex;padding:", ";width:100%;flex-flow:column;align-items:center;justify-content:center;", ""], theme('default.padding'), spacingVer(15));
export var UILoaderBody = styled.div.withConfig({
  displayName: "UILoaderBody",
  componentId: "sc-ymhjm4-1"
})(["background-color:", ";padding:5px;border-radius:50%;box-shadow:", ";", "{display:block;}"], theme('color.white'), theme('default.box.shadow'), UISpinner);
var UILoaderLabel = styled.div.withConfig({
  displayName: "UILoaderLabel",
  componentId: "sc-ymhjm4-2"
})([""]);

var UILoaderAdapter = function UILoaderAdapter(_ref) {
  var children = _ref.children,
      label = _ref.label,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? true : _ref$loading,
      themeColorPrimary = _ref.themeColorPrimary,
      props = _objectWithoutProperties(_ref, _excluded);

  if (!loading && !children) {
    return null;
  }

  if (!loading && children) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    "data-testid": "ui-loader"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(UILoaderBody, {
      children: /*#__PURE__*/_jsx(UISpinner, {
        size: "large",
        themeColorPrimary: themeColorPrimary,
        variant: "primary"
      })
    }), label && /*#__PURE__*/_jsx(UILoaderLabel, {
      children: label
    })]
  }));
};

export var UILoader = styled(UILoaderAdapter).withConfig({
  displayName: "UILoader",
  componentId: "sc-ymhjm4-3"
})(["display:flex;padding:", ";width:100%;flex-flow:column;align-items:center;justify-content:center;", ""], theme('default.padding'), spacingVer(15));
export default UILoader;